import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda'
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { selectTemplatesListItems, selectTemplatesQueryItems } from '../../../../redux/templates/selector';
import { selectCurrent } from '../../../../redux/settings/selectors';
import { selectCategoriesListItems } from '../../../../redux/categories/selector';
import { selectProductListItems } from '../../../../redux/products/selector';
import { selectTenantFunctionsListItems } from '../../../../redux/tenant-functions/selector';
import { selectRewardPointsListItems } from '../../../../redux/reward-points/selector';
import { selectDiscountsListItems } from '../../../../redux/discounts/selector';
import { selectPolicyCollectionsListItems } from '../../../../redux/collections/selector';
import { selectListItems } from '../../../../redux/channel/selector';
import { selectAnnouncementsListItems } from '../../../../redux/announcements/selector';
import { selectHelpTopicsListItems } from '../../../../redux/help-topics/selector';
import { selectTierPricesListItems } from '../../../../redux/tier-prices/selector';
import { selectDeliverysListItems } from '../../../../redux/deliveries/selector';
import { templates } from '../../../../redux/templates/action';
import { channel } from '../../../../redux/channel/action';
import { tenantFunctions } from '../../../../redux/tenant-functions/action';
import { categories } from '../../../../redux/categories/action';
import { announcements } from '../../../../redux/announcements/action';
import { helpTopics } from '../../../../redux/help-topics/action';
import { discounts } from '../../../../redux/discounts/action';
import { policyCollections } from '../../../../redux/collections/action';
import { rewardPoints } from '../../../../redux/reward-points/action';
import { tierPrices } from '../../../../redux/tier-prices/action';
import { deliveries } from '../../../../redux/deliveries/action';
import { products } from '../../../../redux/products/action';
import { deepCopy } from '../../../../common/services/common.service';
import { settings } from '../../../../redux/settings/actions';
import UploadFiles from '../../../../models/UploadFile';
import PageLoader from '../../../../components/PageLoader';

import { selectOrganizationUnitsListItems } from '../../../../redux/organizationUnits/selector';
import TemplateComponent from '../components/templates/template.component';
let currentChange: any = {}
const TemplateContainer= ({ onSubmit,cardDetailInfo }: any) => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectTemplatesQueryItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const categoriesLists = useSelector(selectCategoriesListItems)
  const productsLists = useSelector(selectProductListItems)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
  const rewardsPointsLists = useSelector(selectRewardPointsListItems)
  const discountsLists = useSelector(selectDiscountsListItems)
  const collectionPolicyLists = useSelector(selectPolicyCollectionsListItems)
  const channelLists= useSelector(selectListItems)
  const announcementsData = useSelector(selectAnnouncementsListItems)
  const helpTopicsItems = useSelector(selectHelpTopicsListItems)
  const tierPricesItems = useSelector(selectTierPricesListItems)
  const deliveryItemsData = useSelector(selectDeliverysListItems)
  const templatesItems = useSelector(selectTemplatesListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [
  selectedTemplate,
  setSelectedTemplate
] = useState<any>({ BodyContent: '',
  DesignFileurls: [],
  Attachmenturls: [],
  MappedEntities: []})
const [
  selectedFunctions,
  setSelectedFunctions
] = useState<any>([])

  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const [
    templateImageIndex,
    setTemplateImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
//   const fetchTemplateyId= ()=>{
//     dispatch(templates.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates/query`,entity:'templates',jsonData:{
          
//     Records: [
//       {
        
          
//               "Id": parmas?.id
          
      
       
//       }
//     ]
  
// }})).then(()=>{
//   setIsQuery(true)
// }).then(()=>{
//   setIsLoading(false)
// })
//   }

  useEffect(
    () => {
      dispatch(channel.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`,entity:'channels',jsonData:{}})).then(()=>{
        dispatch(tenantFunctions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenant-domain-functions/list`,entity:'tenantFunctions',jsonData:{
          Filters: [
            {
              FieldName: 'IsTemplateMappingEnabled',
              FieldText: 'TemplateMappingEnabled',
              FieldType: 'boolean',
              FilterOperatorId: 1,
              FieldValue: true
            }
          ]
       
    
        }}))
      })
      .then(()=>{
      if (parmas?.id > 0) {
        setSelectedTemplate(cardDetailInfo)
        const localSelectedService = addNewRow({ selectedFunctionArg: cardDetailInfo?.MappedEntities });
        setSelectedFunctions(localSelectedService)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: cardDetailInfo?.Attachmenturls });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
      else{
        const localSelectedFunction = addNewRow({ selectedFunctionArg: selectedFunctions });
        setSelectedFunctions(localSelectedFunction)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    })},
    []
  )

//   const  handleCategorySearch = ({ event }: any) => {
//     dispatch(categories.list({
//       url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
//       entity: 'categories',
//       jsonData: {
//           "Filters": [
//             {
//               "FieldName": "CategoryName",
//               "FilterOperatorId": 6,
//               "FieldValue": event,
//               "FieldType": "text"
//             }
//           ],
//         }}))
//   }
//   const  handleAnnouncementSearch = ({ event }: any) => {
//     dispatch(announcements.list({
//       url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements/list`,
//       entity: 'announcements',
//       jsonData: {
//           "Filters": [
//             {
//               "FieldName": "Title",
//               "FilterOperatorId": 6,
//               "FieldValue": event,
//               "FieldType": "text"
//             }
//           ],
//         }}))
//   }

//   const  handleChannelSearch = ({ event }: any) => {
//      dispatch(channel.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`,
//       jsonData: {
//           "Filters": [
//             {
//               "FieldName": "Name",
//               "FilterOperatorId": 6,
//               "FieldValue": event,
//               "FieldType": "text"
//             }
//           ],
//         }}))
//   }

//   const  handleTopicSearch = ({ event }: any) => {
//     dispatch(helpTopics.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics/list`,entity:'helpTopics',jsonData:{
//          "Filters": [
//            {
//              "FieldName": "Title",
//              "FilterOperatorId": 6,
//              "FieldValue": event,
//              "FieldType": "text"
//            }
//          ],
//        }}))
//  }

//  const  handleDiscountSearch = ({ event }: any) => {
//   dispatch(discounts.list({
//     url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/merchandising/discounts/list`,
//     entity: 'discounts',
//    jsonData: {
//        "Filters": [
//          {
//            "FieldName": "Name",
//            "FilterOperatorId": 6,
//            "FieldValue": event,
//            "FieldType": "text"
//          }
//        ],
//      }}))
// }

// const  handleCollectionPolicySearch = ({ event }: any) => {
//   dispatch(policyCollections.list({
//     url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/organization/collections/list`,
//     entity: 'policyCollections',
//    jsonData: {
//        "Filters": [
//          {
//            "FieldName": "Name",
//            "FilterOperatorId": 6,
//            "FieldValue": event,
//            "FieldType": "text"
//          }
//        ],
//      }}))
// }
// const  handleRewardPointSearch = ({ event }: any) => {
//   dispatch(rewardPoints.list({
//     url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/merchandising/reward-points/list`,
//     entity: 'rewardPoints',
//    jsonData: {
//        "Filters": [
//          {
//            "FieldName": "RewardPointName",
//            "FilterOperatorId": 6,
//            "FieldValue": event,
//            "FieldType": "text"
//          }
//        ],
//      }}))
// }

// const  handleTierPriceSearch = ({ event }: any) => {
//   dispatch(tierPrices.list({
//     url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/pricing/tier-prices/list`,
//     entity: 'tierPrices',
//    jsonData: {
//        "Filters": [
//          {
//            "FieldName": "Name",
//            "FilterOperatorId": 6,
//            "FieldValue": event,
//            "FieldType": "text"
//          }
//        ],
//      }}))
// }
// const  handleDeliverySearch = ({ event }: any) => {
//   dispatch(deliveries.list({
//     url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/shipment/deliveries/list`,
//     entity: 'deliveries',
//    jsonData: {
//        "Filters": [
//          {
//            "FieldName": "Name",
//            "FilterOperatorId": 6,
//            "FieldValue": event,
//            "FieldType": "text"
//          }
//        ],
//      }}))
// }

// const  handleProductSearch = ({ event }: any) => {
//   dispatch(products.list({
//     url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
//     entity: 'products',
//    jsonData: {
//        "Filters": [
//          {
//            "FieldName": "Name",
//            "FilterOperatorId": 6,
//            "FieldValue": event,
//            "FieldType": "text"
//          }
//        ],
//      }}))
// }

  // useEffect(
  //   () => {
        
  //     if (isQuery) {
  //       setSelectedTemplate(queryItems?.result?.items)
  //       const localSelectedService = addNewRow({ selectedFunctionArg: queryItems?.result?.items?.MappedEntities });
  //       setSelectedFunctions(localSelectedService)
  //       const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.Attachmenturls });
  //       setMediaFiles(localSelectedMedia)
  //     }
  //   },
  //   [isQuery]
  // )
  const handleFormAttachmentItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }
 
  const deleteSelectedFunctions = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      selectedFunctions?.splice(
        index,
        1
      )
    }
    handleClose()
  }
  const addNewRow = ({ selectedFunctionArg }: any) => {
    const localSelectedFunction = deepCopy(selectedFunctionArg)
    const newsFunctions = {
      Id: 0,
      OwnerTypeId: 0,
      OwnerId: 0,
      MarketingTemplateId: 0,
      OwnerName: selectedTemplate.Name

    }
    if (localSelectedFunction.length === 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerTypeId !== 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerId !== ''
    ) {
      localSelectedFunction?.push(newsFunctions)
    }

    return localSelectedFunction
  }
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedTemplate({ ...selectedTemplate, [field]: event });
  }
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedFunctions);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setSelectedFunctions(items);
  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileMappingURL !== ''
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setCombinationmediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileMappingURLDONE'
    setMediaFiles(localSelectedMedia)
  }


  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setTemplateImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Campaign',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
    mediaFiles[templateImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
      selectedTemplate.IsApproved = true;
      selectedFunctions.splice(
        selectedFunctions.length - 1,
        1
      );   
      selectedTemplate.Id = 0
      selectedTemplate.MappedEntities = 
      [
        {
          "Id": 0,
          "OwnerName": "string",
          "Name": "new",
          "Description": "string",
          "IsFunction": true,
          "IsDomain": false,
          "MarketingTemplateId": 0,
          "IsApproved": true,
          "DisplayOrder": 0
      },
      ]
   onSubmit(selectedTemplate)

  }

  const setCombinationInfo = async () => {
    let localSelectedFunction = deepCopy(selectedFunctions)
    localSelectedFunction.splice(
      currentChange.idx,
      1,
      { ...localSelectedFunction[currentChange.idx] }
    );
    localSelectedFunction = addNewRow({ selectedFunctionArg: localSelectedFunction });
    currentChange.field = 'OwnerTypeIdDONE'
    setSelectedFunctions(localSelectedFunction)
  }

  useEffect(
    () => {
      if ( currentChange.field === 'OwnerId') {
        setCombinationInfo()
      }
    },
    [selectedFunctions]
  )


  useEffect(
    () => {

    },
    [selectedTemplate]
  )
  useEffect(
    () => {
      if (currentChange.field === 'FileMappingURL') {
        setCombinationmediaInfo()
      }
    },
    [mediaFiles]
  )
    return (
    <>
     {/* {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         />} */}
     {isLoading ? <PageLoader /> : 
          <TemplateComponent 
          handleInnerFormChange={handleInnerFormChange}
          selectedTemplate={selectedTemplate}
          selectedFunctions={selectedFunctions}
          handleFormSubmit={handleFormSubmit}
          categories={categoriesLists?.result?.items}
          announcements={announcementsData?.result?.items}
          // certificates={certificates}
          channels={channelLists?.result?.items}
          // collections={collectionPolicyLists?.result?.items}
          // courses={courses}
          // learningPaths={learningPaths}
          // modules={modules}
          topics={helpTopicsItems?.result?.items}
          // vendors={vendors}
          organizationUnits={organizationUnitsLists?.result?.items}
          discounts={discountsLists?.result?.items}
          rewards={rewardsPointsLists?.result?.items}
          tierPrices={tierPricesItems?.result?.items}
          collectionPolicies={collectionPolicyLists?.result?.items}
          deliveries={deliveryItemsData?.result?.items}
          products={productsLists?.result?.items}
          // handleCategorySearch={handleCategorySearch}
          // handleAnnouncementSearch={handleAnnouncementSearch}
          // // handleCertificateSearch={handleCertificateSearch}
          // handleChannelSearch={handleChannelSearch}
          // // handleCollectionSearch={handleCollectionSearch}
          // // handleCourseSearch={handleCourseSearch}
          // // handleLearningPathSearch={handleLearningPathSearch}
          // // handleModuleSearch={handleModuleSearch}
          // handleTopicSearch={handleTopicSearch}
          // // handleVendorSearch={handleVendorSearch}
          // handleDiscountSearch={handleDiscountSearch}
          // handleRewardPointSearch={handleRewardPointSearch}
          // handleCollectionPolicySearch={handleCollectionPolicySearch}
          // handleTierPriceSearch={handleTierPriceSearch}
          // handleDeliverySearch={handleDeliverySearch}
          // handleProductSearch={handleProductSearch}
          handleFormItemChange={handleFormItemChange}
          deleteSelectedFunctions={deleteSelectedFunctions}
          tenantFunction={tenantfunctionsLists?.result?.items}
          templates={templatesItems?.result?.items}
          tenantFunctions={R.map((name: any) => R.assoc(
           'EntityId',
           name.Entities[0]?.Id,
           name
         ))(tenantfunctionsLists?.result?.items)}
         id={parmas?.id}
         changeImage={changeImage}
         mediaFiles={mediaFiles}
         handleFormAttachmentItemChange={handleFormAttachmentItemChange}
          />  }
          </>
    )
    
    }
   
    export default TemplateContainer;